<template>
  <el-carousel   height="440px">
    <el-carousel-item v-for="(item,index) in list" :key="item.id">
      <img :src='`${domain}${item.url}`' alt="">
    </el-carousel-item>
  </el-carousel>
</template>

<script>
export default {
  name: "AppBanner",
  props: {
    list: {
      type: Array,
      default: []
    },
    domain: {
      type: String,
      default: process.env.VUE_APP_DOMAIN
    }
  }
};
</script>

<style lang="less" scoped>

img{
  width: 1200px;
  height: 440px;
}
</style>